import FooterContent from './FooterContent'

export default FooterContent
